<template>
  <p class="p-userauthentication__note" v-if="locale === 'ja'">
    <span class="p-userauthentication__note-text" v-if="fluxTermsUrl && fluxPrivacyPolicyUrl">
      ユーザー登録を行うことで、
      <a
        class="p-userauthentication__note-link"
        :href="fluxTermsUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('AuthenticateUserPage.termsOfService') }}
      </a>
      、
      <a
        class="p-userauthentication__note-link"
        :href="fluxPrivacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('AuthenticateUserPage.privacyPolicy') }}
      </a>
      に同意するものとします。
    </span>
  </p>
  <p class="p-userauthentication__note" v-if="locale === 'en'">
    <span class="p-userauthentication__note-text" v-if="fluxTermsUrl && fluxPrivacyPolicyUrl">
      By your registration, we assume that you have accepted the
      <a
        class="p-userauthentication__note-link"
        :href="fluxTermsUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('AuthenticateUserPage.termsOfService') }}
      </a>
      and
      <a
        class="p-userauthentication__note-link"
        :href="fluxPrivacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('AuthenticateUserPage.privacyPolicy') }}
      </a>
    </span>
  </p>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'AuthUserNote',
  setup() {
    const { locale } = useI18n()
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    return {
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      ...useI18n(),
    }
  },
})
</script>

<style scoped lang="scss"></style>
